<template>
  <div ref="parentRef" class="questionnaire">
    <Component
      :is="currentComponent"
      :key="index"
      :loading="loading"
      @next="emit('next')"
      @register="emit('register')"
    ></Component>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  index: number
  loading: boolean
}>()

const emit = defineEmits<{
  (e: 'next'): void
  (e: 'register'): void
}>()

const stepsMap = [
  resolveComponent('QuestionnaireStepOne'),
  resolveComponent('QuestionnaireStepTwo'),
  resolveComponent('QuestionnaireStepThree'),
]

const currentComponent = computed(() => stepsMap[props.index])

const [parentRef] = useAutoAnimate()
</script>

<style scoped></style>
